import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import BetslipSubmitForm from "./betslip-submit-form";
import {
  addToSlip,
  findPostableSlip,
  // findPostableSlipViax,
  getBetslip,
  // getBetslipViax,
  getJackpotBetslip,
  removeFromJackpotSlip,
  removeFromSlip,
  // removeFromSlipViax,
} from "../utils/betslip";
import useWindowDimensions from "../header/Dimensions";
import { getFromLocalStorage, setLocalStorage } from "../utils/local-storage";
import DecodeCode from "./decode";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  removePickedData,
  removeSelected,
  setMatchBetslip,
  setPickedData,
  setSelected,
  startBetslipValidation,
  stopBetslipValidation,
  betslipValidation,
  // setMatchBetslipViax,
} from "../../redux/bettingSlice";
import Notify from "../utils/Notify";
import { Widget } from "../recommender/betslipRecommender";
import { externalChangeCallback, onBetSlipChanged } from "../recommender/Index";
import { setState } from "../../redux/dataSlice";

const SlipLink2 = ({ slip }) => {
  const isDisabled = slip?.disable;
  const linkTo =
    slip?.bet_type === "0"
      ? `/match/${slip?.parent_match_id}`
      : `/match/live/${slip?.parent_match_id}`;
  return (
    <Link
      to={isDisabled ? "#" : linkTo}
      style={{ color: "inherit", fontStyle: "inherit" }}
      className={"g url-link"}
    >
      <div className="bet-value">
        <b>
          {
            <span className={"team-info-slip-list text-ellipsis"}>
              <span className={"slip-team text-ellipsis"}>
                {slip.home_team} &nbsp; Vs.&nbsp; {slip.away_team}
              </span>
            </span>
          }
        </b>
      </div>
      <div className={"d-flex w-100 slip-dim-color-selections"}>
        <div className="row d-flex flex-column">
          <div className="bet-value picks-user-slip">
            {" "}
            {slip.odd_type} -
            <span className={"pick-user-match"}>{slip.bet_pick}</span>
            &nbsp;
            <span style={{ color: "var(--red)" }}>
              {Number(slip.bet_type) === 1 ? " Live'" : ""}
            </span>
          </div>
          <div className="bet-value time-slip-value"> {slip?.start_time}</div>
        </div>
        <br />
      </div>
      <div className="row">
        <div className="warn">{slip?.comment} </div>
      </div>
    </Link>
  );
};

const BetSlip = (props) => {
  const { jackpot, betslipValidationData, jackpotData, live } = props;
  const [message, setMessage] = useState(null);
  const [qualifiesBonus, setQualifiesBonus] = useState(false);
  const settings = useSelector((state) => state.data.app_config);
  const { height, width } = useWindowDimensions();
  const dispatchRedux = useDispatch();
  const pathname = window.location.pathname;

  const prevKeysRef = useRef([]);

  const [, setPopUpHeight] = useState(0);
  const [totalOdds, setTotalOdds] = useState(1);

  const [betslipsData, setBetslipsData] = useState(getBetslip());
  const widgetRef = useRef(null);
  const scrollBottomRef = useRef(null);
  const scrollableRef = useRef(null);

  const slip_data = useSelector((state) => state.betting.betslip);
  const slip_has_live_interval = useSelector(
    (state) => state.betting.slip_has_live_interval
  );
  const userData = useSelector((state) => state.auth.user);
  const [user, setUser] = useState(getFromLocalStorage("user"));
  useEffect(() => {
    if (userData) {
      setUser(userData || getFromLocalStorage("user"));
    }
  }, [userData]);

  useEffect(() => {
    setBetslipsData(slip_data || getBetslip());
  }, [slip_data]);

  const totalGames = betslipsData ? Object.keys(betslipsData).length : 0;
  const producer_down = useSelector((state) => state.matchesData.producer_down);
  const live_producer_down = useSelector(
    (state) => state.matchesData.live_producer_down
  );

  useEffect(() => {
    if (slip_data) {
      jackpot && Object.keys(getJackpotBetslip() || {}).length == 0
        ? setBetslipsData(null)
        : setBetslipsData(slip_data);
    }
  }, [slip_data]);

  const validateBetslipwithDbData = useCallback(() => {
    if (betslipValidationData && betslipsData) {
      let clone_slip = { ...betslipsData }; // Create a shallow clone of betslipsData

      Object.entries(betslipValidationData)?.forEach(([key, slipdata]) => {
        let match_id = slipdata.parent_match_id;
        let slip = clone_slip[match_id];
        if (slip) {
          slip = { ...slip, bet_pick: slipdata.bet_pick };

          if (slipdata.live === 0 && producer_down) {
            slip = {
              ...slip,
              comment: `Betting on this market is ${"suspended"}`,
              disable: true,
            }; // Create a new object with updated properties
          }
          if (slipdata.live === 1 && live_producer_down) {
            slip = {
              ...slip,
              comment: `Betting on this market is ${"suspended"}`,
              disable: true,
            }; // Create a new object with updated properties
          }

          if (slipdata.odd_active === 0) {
            slip = {
              ...slip,
              comment: "Option not active for betting",
              disable: true,
            }; // Create a new object with updated properties
          }

          if (
            slipdata.market_active === 0 ||
            (slipdata.market_active !== "Active" &&
              slipdata.market_active !== 1)
          ) {
            slip = {
              ...slip,
              comment: `Betting on this market is ${
                slipdata.market_active === 0
                  ? "suspended"
                  : slipdata.market_active
              }`,
              disable: true,
            }; // Create a new object with updated properties
          } else if (
            [
              "Suspended",
              "Deacticated",
              "Ended",
              "Expired",
              "Abandoned",
              "Finished",
            ].includes(slipdata.event_status)
          ) {
            slip = {
              ...slip,
              comment: `This event is ${slipdata.event_status}`,
              disable: true,
            }; // Create a new object with updated properties
          } else if (slipdata.active !== 1) {
            slip = {
              ...slip,
              comment: "Market not active for betting",
              disable: true,
            }; // Create a new object with updated properties
          } else if (slip.odd_value !== slipdata.odd_value) {
            slip = {
              ...slip,
              prev_odds: slip.odd_value,
              odd_value: slipdata.odd_value,
              comment: "The odds for this event have changed",
              disable: false,
            }; // Create a new object with updated properties
          } else {
            if (slip.disable !== false) {
              slip = { ...slip, comment: null }; // Create a new object with updated properties
            }
            slip = { ...slip, disable: false }; // Create a new object with updated properties
          }
          clone_slip[match_id] = slip;
        }
      });

      const betslip_data = {
        betslip_type: "betslip",
        data: clone_slip,
      };
      setLocalStorage("betslip", clone_slip);
      dispatchRedux(setMatchBetslip(betslip_data));
    }
  }, [betslipValidationData]);

  useEffect(() => {
    validateBetslipwithDbData();
  }, [validateBetslipwithDbData]);

  //betslip update
  const updateBetslip = useCallback(() => {
    if (betslipsData) {
      let odds = Object.values(betslipsData).reduce(
        (previous, { odd_value }) => {
          return previous * odd_value;
        },
        1
      );
      setTotalOdds(odds);
    }
  }, [betslipsData]);

  useEffect(() => {
    updateBetslip();
  }, [updateBetslip]);

  useEffect(() => {
    const betslipData = findPostableSlip();

    if (!slip_has_live_interval) {
      if (betslipData?.length > 0) {
        dispatchRedux(
          startBetslipValidation({
            endpoint: "v2/betslip-validation",
            method: "POST",
            interval: 20000,
            data: findPostableSlip(),
          })
        );
      }
    }
    return () => {
      stopBetslipValidation();
    };
  }, [slip_has_live_interval]);

  const navigate = useNavigate();

  const handledRemoveSlip = (match) => {
    let betslip =
      jackpot !== true
        ? removeFromSlip(match.parent_match_id)
        : removeFromJackpotSlip(match.match_id);

    // let betslip_viax = jackpot !== true && removeFromSlipViax(match.match_id);

    let match_selector = jackpot
      ? match.match_id + "_selected"
      : match.parent_match_id + "_selected";

    // // Create betslip data object for viax betslip
    // const betslip_data_viax = {
    //   betslip_type: "betslip_viax",
    //   data: betslip_viax,
    // };

    // dispatchRedux(setMatchBetslipViax(betslip_data_viax));

    setBetslipsData(betslip);
    const betslip_data = {
      betslip_type: "betslip",
      data: betslip,
    };
    dispatchRedux(setMatchBetslip(betslip_data));

    dispatchRedux(removeSelected(match_selector));

    dispatchRedux(removePickedData(""));

    if (Object.keys(betslip).length === 0) {
      navigate("/");
    }
  };

  const updateBonusStateCallback = useCallback(() => {
    let maxBonusGames = Number(settings?.betnareBonus?.bonusBetLegs);
    let perSlipBonusOdd = settings?.betnareBonus?.minBonusOdd;
    let fixedOdd = settings?.betnareBonus?.fixedOdd === "1";
    let bonusBetFixedAmount = settings?.betnareBonus?.bonusBetAmount;
    let message = "";
    let userBonus = Number(user?.bonus || 0);
    let bonusBetEligible = false;

    if (
      totalGames < maxBonusGames &&
      maxBonusGames > 1 &&
      Number(user?.balance) < 1
    ) {
      let remainingGames = Number(maxBonusGames) - Number(totalGames);
      message = `Congratulations, you qualify for a bonus bet. Bonus rules are as follows: Add ${remainingGames} game${
        remainingGames > 1 ? "s" : ""
      } with a minimum odd of ${perSlipBonusOdd}. Your available bonus balance is ${
        user?.bonus
      }`;
    } else if (totalGames >= maxBonusGames && maxBonusGames > 1) {
      message = `Congratulations, you are eligible for a bonus bet. Allowed Bonus Bet Amount is KES ${bonusBetFixedAmount}`;
    } else {
      message = "";
    }

    // let bonusBetSportID = settings?.betnareBonus?.bonusSport;
    let odds = Object.values(betslipsData || []).filter(
      (slip) =>
        Number(slip.odd_value) >= Number(settings?.betnareBonus?.minBonusOdd) &&
        !slip?.disable
    );

    let bonusQualificationOdds = odds.length;
    let remainingGames = Number(maxBonusGames) - Number(bonusQualificationOdds);
    bonusBetEligible =
      remainingGames > 0 &&
      userBonus > Number(bonusBetFixedAmount) &&
      totalGames > 0 &&
      user?.balance < 1;
    // console.log("bonusBetElligible ", bonusBetEligible, user?.balance)

    if (
      bonusBetEligible &&
      maxBonusGames > 1 &&
      remainingGames >= 1 &&
      Number(user?.balance) < 1
    ) {
      message = `To qualify for a bonus bet, please select ${remainingGames} more game${
        remainingGames > 1 ? "s" : ""
      } each with minimum odds ${
        Number(fixedOdd) === 1 ? "of " + perSlipBonusOdd : ""
      }.`;
    } else {
      if (bonusQualificationOdds >= 1 && Number(user?.balance) < 1) {
        bonusBetEligible = false;
        message = `Congratulations, you can now place a bonus bet. Available bonus balance is ${user?.bonus}`;
      }
    }

    if (userBonus < 1 || Number(user?.balance) >= 1) {
      message = "";
    }

    let alertMessage = {
      status: bonusBetEligible ? 500 : 201,
      message: message,
    };
    // console.log("user balance", user?.balance)

    setMessage(alertMessage);
    setQualifiesBonus(
      bonusBetEligible && totalGames <= maxBonusGames && user?.balance < 1
    );
  }, [totalGames, settings, user, betslipsData, setMessage, setQualifiesBonus]);

  useEffect(() => {
    updateBonusStateCallback();
  }, [updateBonusStateCallback]);

  const BonusAlert = () => {
    let c = message?.status === 201 ? "success" : "warning";
    return (
      <>
        {message?.status && message?.message && (
          <div
            className={`fade col shadow p-0 alert-${c} show position-sticky alert-message-line-height`}
          >
            {message.message}
          </div>
        )}
      </>
    );
  };

  //   console.log("bonusMessage data", message?.message);

  useEffect(() => {
    const remainingScreenHeight =
      height - (jackpot ? (user ? 430 : 400) : user ? 560 : 500);
    // Set the pop up component height to be 20% of the remaining screen height
    setPopUpHeight(remainingScreenHeight);
  }, []);

  // let changeCallback = undefined;

  // // Function to register a callback for bet slip changes
  // function  onBetSlipChanged(callback) {
  //   changeCallback = callback;

  //   console.log("callback function changed BETSLIP", changeCallback);
  //   changeCallback && changeCallback(betSlipState);
  // }

  // Initialize the betSlipState object
  let betSlipState = {
    betslip: [],
    combinedOddsValue: undefined,
  };

  const clear_rep = (str) => {
    return str.replace(/\s/g, "");
  };

  const handleButtonOnClick = (target, event) => {
    if (target === "externalOutcome") {
      // console.log("target data", event.externalMarket.status.isActive)

      const attributes = {
        parent_match_id: event?.externalEvent?.id,
        sub_type_id: event?.externalMarket?.id,
        odd_key: event?.externalOutcome?.name,
        odd_value: event?.externalOutcome?.odds,
        bet_type: event?.externalEvent?.isLive === false ? "0" : "1",
        odd_type: event?.externalMarket?.name,
        start_time: event?.externalEvent?.date,
        home_team: event?.externalEvent?.teams[0]?.name,
        away_team: event?.externalEvent?.teams[1]?.name,
        outcome_id: event?.externalOutcome?.id,
        sport_name: event?.externalEvent?.sport.name,
        market_active: event?.externalMarket?.status.isActive,
      };

      const newBet = {
        externalEventId: event?.externalEvent.id,
        externalMarketId: event?.externalMarket.id,
        externalOutcomeId: event?.externalOutcome.id,
      };

      betSlipState = {
        betslip: [...betSlipState.betslip, newBet],
        // combinedOddsValue: '14.52' // Just an example, replace with your actual calculation
      };

      // Update the betSlipState by adding the new bet and the combinedOddsValue
      externalChangeCallback && externalChangeCallback(betSlipState);

      let cstm = clear_rep(
        attributes.parent_match_id +
          "" +
          attributes.sub_type_id +
          attributes.outcome_id
      );
      const maxPickReached = () => {
        // console.log("max_pick_reached")
        dispatchRedux(removePickedData(" "));
        // dispatchRedux(removePickedData(""));
        Notify({
          status: 401,
          message: "Maximum selections reached",
          token: "",
        });
      };
      const betItems = getBetslip();

      const priority = Object.keys(betItems || {}).length + 1; // Incremental priority
      const slip = {
        match_id: attributes.parent_match_id,
        parent_match_id: attributes.parent_match_id,
        special_bet_value: "",
        sub_type_id: attributes.sub_type_id,
        bet_pick: attributes.odd_key,
        start_time: attributes.start_time,
        odd_value: attributes.odd_value,
        home_team: attributes.home_team,
        away_team: attributes.away_team,
        bet_type: attributes.bet_type,
        odd_type: attributes.odd_type,
        sport_name: attributes.sport_name,
        live: live,
        outcome_id: attributes.outcome_id,
        ucn: clear_rep(
          `${attributes.match_id ?? attributes.parent_match_id}${
            attributes.sub_type_id
          }${attributes.outcome_id}
                    `
        ),
        market_active: attributes.market_active,
        position: 0,
        priority: priority, // Assign priority
      };

      // if (cstm === match?.ucn) {
      let betslip;
      const updateRedux = () => {
        betslip = addToSlip(slip);
        dispatchRedux(
          setSelected(attributes.parent_match_id + "_selected", cstm)
        );
        let url = new URL(window.location.href);
        const pathname = window.location.pathname;

        if (pathname.includes("match")) {
          let matchIdFromUrl = url.pathname.split("/").pop(); // This will get '50852129' from '/match/50852129'
          console.log("match information ", matchIdFromUrl);

          if (matchIdFromUrl === attributes.parent_match_id) {
            dispatchRedux(setPickedData(cstm));
          }
        }

        // dispatchRedux(setPickedData(cstm));
      };

      updateRedux();

      if (
        Object.keys(betItems || {}).length ===
        Number(settings?.sportsBookLimits?.multiBetMaxSelections)
      ) {
        maxPickReached();
      } else {
        updateRedux();
      }

      const betslip_data = {
        betslip_type: "betslip",
        data: betslip,
      };

      dispatchRedux(setMatchBetslip(betslip_data));
      // Dispatch the action with the appropriate interval duration
      dispatchRedux(
        betslipValidation({
          endpoint: "v2/betslip-validation",
          method: "POST",
          data: betslip,
          payload: betslip,
        })
      );
    }
    if (target == "externalEvent") {
      navigate("/match/" + event?.externalEvent?.id);
    }
  };

  const [previousLength, setPreviousLength] = useState(
    Object.keys(betslipsData || {})?.length
  );

  useEffect(() => {
    const currentLength = Object.keys(betslipsData || {})?.length;
    if (currentLength > previousLength && width < 992) {
      if (scrollableRef.current) {
        scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
      }
      if (widgetRef.current) {
        widgetRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else if (currentLength > previousLength) {
      if (scrollableRef.current) {
        scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
      }
    }
    setPreviousLength(currentLength);
  }, [previousLength, betslipsData]);

  useEffect(() => {
    // Scroll to the widget element when the component mounts
    if (scrollableRef.current && width < 992) {
      scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
    }
    if (widgetRef.current) {
      widgetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const showWidget = useSelector((state) => state.data.show_similar_widget);
  const showRWidget = useSelector(
    (state) => state.data.show_recommender_widget
  );

  useEffect(() => {
    console.log(
      "sir removing resetting show widget",
      "betslip recommender sir"
    );
    console.log(pathname, "show widget pathname");

    console.log("show widget", showWidget);
    console.log("show R widget", showRWidget);

    const shouldShow =
      betslipsData &&
      Object.keys(betslipsData).length !== 0 &&
      (pathname.includes("betslip-slip") || width > 991);

    console.log("show widget available", shouldShow);
    let timer;

    if (shouldShow) {
      console.log("Conditions met: will show widget in 700ms");

      timer = setTimeout(() => {
        dispatchRedux(setState("show_similar_widget", true));

        console.log("showing widget");
      }, 500);

      return () => clearTimeout(timer); // cleanup if deps change
    } else {
      console.log("Conditions NOT met: hiding widget immediately");
      window.SIR("removeWidget", "#sr-widget-bets");
      dispatchRedux(setState("show_similar_widget", false));
    }
    const abort = new AbortController();
    return () => {
      abort.abort();
      console.log("Cleanup: clearing timer and hiding widget");

      clearTimeout(timer);
    };
  }, [betslipsData, pathname, width]);

  // useEffect(() => {
  //   const abort = new AbortController();

  //   // Effect cleanup function
  //   return () => {
  //     abort.abort();

  //     // Remove widget conditionally based on pathname and width
  //     if (width < 991) {
  //       // Mobile
  //       if (!pathname.includes("betslip-slip")) {
  //         console.log(
  //           "sir removing Cleaning up widget on mobile, pathname does not include betslip-slip",
  //           pathname,
  //           "width",
  //           width
  //         );

  //         window.SIR("removeWidget", ".sr-widget-bets");
  //       }
  //     } else {
  //       // Desktop
  //       // Widget should not be removed on desktop

  //       window.SIR("removeWidget", ".sr-widget-bets");
  //       console.log(
  //         "removing widget cleanup On desktop, no cleanup for widget",
  //         pathname,
  //         "width",
  //         width
  //       );
  //     }
  //   };
  // }, [pathname]);

  const pathLocation = window.location.pathname;
  const [showMessage, setShowMessage] = useState(true);
  return (
    <div
      className={`bet-body text-white ${
        showMessage ? "responsive-margin" : ""
      }`}
    >
      {!jackpot && <BonusAlert />}
      <div
        className={`flow  slip-top ${
          user
            ? jackpot
              ? "slip-max"
              : "slip-height slip-log-max"
            : "slip-max"
        } overflow-auto`}
        ref={width >= 992 ? scrollableRef : null}
      >
        <div
          ref={width < 992 ? scrollableRef : null}
          className={`${
            pathLocation === "/betslip-slip"
              ? user && !jackpot
                ? "slip-bottom-betlip-active"
                : "slip-bottom-betlip"
              : "slip-bottom-space"
          }`}
        >
          <ul className={"slip-bottom-space-list"}>
            {(betslipsData && Object.keys(betslipsData)?.length == 0) ||
            betslipsData == null ? (
              jackpot ? (
                ""
              ) : (
                <DecodeCode />
              )
            ) : (
              Object.entries(betslipsData || {})
                .sort(([, slipA], [, slipB]) => slipA.priority - slipB.priority)
                .map(([match_id, slip], index) => {
                  let odd = slip.odd_value;
                  let no_odd_bg = odd === 1 ? "#f29f7a" : "";
                  // console.log(slip)
                  return (
                    <div
                      key={index}
                      className={`d-flex slip-bg slip-optional-statuses ${
                        slip?.disable ? "warn" : ""
                      }`}
                    >
                      <div className="bet-cancel">
                        <input
                          id={slip.match_id}
                          type="submit"
                          value="X"
                          onClick={() => handledRemoveSlip(slip)}
                        />
                      </div>
                      <div className="d-flex width-slip-item-container">
                        <li
                          className={`bet-option hide-on-affix ${
                            slip?.disable ? "warn" : ""
                          }`}
                          key={match_id}
                          style={{ background: no_odd_bg }}
                        >
                          <SlipLink2 slip={slip} />
                        </li>
                      </div>
                      <div className="d-flex align-items-center">
                        <b>
                          <span className="bet-odd">
                            {slip.odd_value}
                            {slip.odd_value === 1 && (
                              <span
                                style={{
                                  color: "#cc0000",
                                  fontSize: "11px",
                                  display: "block",
                                }}
                              >
                                Market Disabled
                              </span>
                            )}
                          </span>
                        </b>
                      </div>
                    </div>
                  );
                })
            )}

            {showWidget && (
              <div ref={widgetRef}>
                <Widget
                  pathname={pathname}
                  betslipsData={betslipsData}
                  // onBetSlipChanged={onBetSlipChanged}
                  user={user}
                  width={width}
                  prevKeysRef={prevKeysRef}
                  live={live}
                  showWidget={showWidget}
                  // handleButtonOnClick={handleButtonOnClick}
                />
              </div>
            )}
          </ul>
        </div>
      </div>
      <div ref={scrollBottomRef}></div>

      <div className="bottom">
        <BetslipSubmitForm
          jackpotData={jackpotData}
          live={live}
          totalOdds={totalOdds}
          betslip={betslipsData}
          totalGames={betslipsData ? Object.keys(betslipsData).length : 0}
          jackpot={jackpot}
          bonusBet={qualifiesBonus}
          setShowMessage={setShowMessage}
        />
      </div>
    </div>
  );
};
export default React.memo(BetSlip);
